import { render, staticRenderFns } from "./JourneyOnboardingModal.vue?vue&type=template&id=313dfa05&scoped=true&"
import script from "./JourneyOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./JourneyOnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./JourneyOnboardingModal.vue?vue&type=style&index=0&id=313dfa05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313dfa05",
  null
  
)

export default component.exports